import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

import ActionButton from 'components/buttons/ActionButton';

export default function MessageFooter({
  data,
  isSubmitDisabled,
  onRequestError,
  projectId,
  resetRequestError,
  versionId,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const messageParams = {
    dispatches_attributes: data.form.to.map((email) => ({
      email: email.value,
    })),
    message: data.form.message,
    rams_included: data.form.ramsIncluded,
    send_to_self: data.form.sendToSelf,
    subject: data.form.subject,
    training_report_included: data.form.trainingReportIncluded,
  };

  const returnToShowPage = () => {
    window.location.assign(`/projects/${projectId}`);
  };

  const submitMessage = () => {
    resetRequestError();

    axios
      .post(`/messages`, {
        version_id: versionId,
        message: messageParams,
        password_required: data.form.passwordRequired,
        password: data.form.password,
        evidence_included: data.form.evidenceIncluded,
      })
      .then(returnToShowPage)
      .catch(onRequestError);
  };

  return (
    <PortaledButtons>
      <OutlinedButton
        className='tw-mr-3'
        color='blue-grey'
        href={`/projects/${projectId}`}
        onDark={true}
        size='md'
      >
        {i18nTShared('cancel')}
      </OutlinedButton>
      <ActionButton
        buttonText={i18nTShared('send')}
        disabledClasses='tw-pointer-events-none tw-text-grey-600 tw-bg-transparent tw-border-grey-600'
        isDisabled={isSubmitDisabled}
        onClick={submitMessage}
        styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--mint tw-apply-filled-button--on-dark'
      />
    </PortaledButtons>
  );
}

MessageFooter.propTypes = {
  data: PropTypes.object.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  onRequestError: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  resetRequestError: PropTypes.func.isRequired,
  versionId: PropTypes.string.isRequired,
};

const PortaledButtons = (props) => {
  const destination = document.getElementsByClassName('message-actions');
  return ReactDOM.createPortal(props.children, destination[0]);
};
